import React from "react";
import SubHeading from "../common/SubHeading";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const dentalQuestions = [
  { key: "mercuryFillings", label: "Mercury fillings" },
  { key: "rootCanals", label: "Root canals" },
  { key: "ulcersLesions", label: "Ulcers/lesions" },
  { key: "braces", label: "Braces" },
  { key: "bruxism", label: "Bruxism (clenching)" },
  { key: "toothPain", label: "Tooth pain" },
  { key: "bleedingGums", label: "Bleeding gums" },
  { key: "problemsChewing", label: "Problems chewing" },
  { key: "tongueTies", label: "Tongue/Lip/Cheek ties" },
  { key: "tmj", label: "TMJ" },
  { key: "gingivitis", label: "Gingivitis" },
  { key: "compositeFillings", label: "Composite fillings" },
  { key: "dryMouth", label: "Dry mouth" },
  { key: "wisdomTeethPulled", label: "Wisdom teeth pulled" },
  { key: "badBreath", label: "Bad breath" },
];

const DentalProfileSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <section>
      <SubHeading>Dental Profile</SubHeading>
      <p className="mb-2 text-brand-stone-600">Have you / do you have:</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 bg-brand-stone-50 p-4 rounded-lg">
        {dentalQuestions.map((q) => (
          <Field
            key={q.key}
            path={`dentalProfile.${q.key}`}
            label={q.label}
            type="checkbox"
          />
        ))}
      </div>
    </section>
  );
};

export default DentalProfileSectionV2;